import { Subscription } from '../App';
import { nextDeliveryDate } from '../utils/next-delivery-date';

type SummaryType = {
  nextBillingDate: Date;
  deliveryDate: Date;
  totalPrice: number;
  deliveryPrice: number;
};

export type { SummaryType };

export const createSummary = (subscription: Subscription) => {
  const deliveryDate = nextDeliveryDate(
    [
      subscription.shop.disableDeliveryDaysSun,
      subscription.shop.disableDeliveryDaysMon,
      subscription.shop.disableDeliveryDaysTue,
      subscription.shop.disableDeliveryDaysWed,
      subscription.shop.disableDeliveryDaysThr,
      subscription.shop.disableDeliveryDaysFri,
      subscription.shop.disableDeliveryDaysSat,
    ],
    subscription.nextBillingDate,
    subscription.deliveryDays
  );
  const totalPrice =
    subscription.deliveryPriceAmount +
    subscription.subscriptionLines.reduce((sum, subscriptionLine) => sum + subscriptionLine.currentPriceAmount * subscriptionLine.quantity, 0);

  return {
    nextBillingDate: subscription.nextBillingDate,
    deliveryDate,
    totalPrice,
    deliveryPrice: subscription.deliveryPriceAmount,
  };
};
